import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_56: DocMigration = {
  maxSchemaVersion: "0.0.56",
  description: "update electrical rule id format, add id to all rules, delete orphaned electrical settings",
  apply(json: any) {
    if (!json.settingsOverride) {
      return json;
    }

    const elecSettingsId = json?.settingsOverride["electrical"];
    if (elecSettingsId === undefined) {
      return json;
    }

    const elecSettings = json?.settings[elecSettingsId];
    if (elecSettings === undefined) {
      return json;
    }

    for (const rule of elecSettings?.rules || []) {
      rule.id = uid();
    }

    const settingIdsToDelete: string[] = [];
    for (const settingId in json?.settings) {
      if (settingId === elecSettingsId) {
        //keep electrical settings that are actually used
        continue;
      }
      const setting = json.settings[settingId];
      if (setting?.type === "ELECTRICAL_SETTINGS") {
        settingIdsToDelete.push(settingId);
      }
    }

    // delete orphaned electrical settings
    if (settingIdsToDelete.length > 0) {
      for (const id of settingIdsToDelete) {
        delete json.settings[id];
      }
    }

    return json;
  },
};

export default migration_0_0_56;
